import * as React from "react";
import YouTube, {YouTubeEvent, YouTubeProps} from "react-youtube";
import { logEvent } from "../../lib/analytics";

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: (() => void) | undefined;
  }
}

export interface YoutubeProps {
  videoId: string;
  shouldtrack?: boolean;
}

const YouTubeVideo: React.FC<YoutubeProps> = ({
  videoId,
  shouldtrack = true
}) => {
  const onPlayerReady: YouTubeProps["onReady"] = (event:YouTubeEvent<any>) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };
  
  // Track when user actually starts playing the video
  const onPlay: YouTubeProps["onPlay"] = () => {
    if (shouldtrack) {
      logEvent({
        category: 'Video',
        action: 'play',
        label: `YouTube - ${videoId}`,
      });
    }
  }

  const opts: YouTubeProps["opts"] = {
    height: "300px",
    width: "100%",
    playerVars: {
      autoplay: 0,
    },
  };

  return <YouTube videoId={videoId} opts={opts} onReady={onPlayerReady} onPlay={onPlay} />;
};
export default YouTubeVideo;
